export default {
  activateLandingPageTitle: 'Tapahtumat',
  activateProductCardTitle: 'Tapahtumat',
  activateProductPageTitle: 'Varaa tapahtumia',
  allProductsLandingPageTitle: 'Varaa ainutlaatuisia elämyksiä',
  apply: 'Käytä',
  buyTickets: 'Osta liput',
  cancel: 'Peruuta',
  clear: 'Tyhjennä',
  clearFilters: 'Tyhjennä suodattimet',
  discoverExperiences: 'Tutustu elämyksiin',
  exclusive: 'Eksklusiivinen',
  experience: 'elämys',
  experiencePhotoOfListing:
    'Elämyksen kuva {{photoNumber}} listauksesta {{listingTitle}}',
  experiences: 'elämyksiä',
  filterExperiences: 'Suodata elämyksiä',
  fromListingCard: 'Alkaen',
  hostedBy: 'Isäntänä',
  hostLandingPageTitle: 'Paikalliset elämykset',
  hostProductCardTitle: 'Paikalliset elämykset',
  hostProductPageTitle: 'Varaa paikallisia elämyksiä',
  landingPageTitle: 'Varaa ainutlaatuisia elämyksiä',
  mainLandingPageTitle: 'Kaikki elämykset',
  more: 'Lisää',
  noExperiencesFound: 'Elämyksiä ei löytynyt',
  noExperiencesFoundFor: 'Elämyksiä ei löytynyt haulle',
  experiencesFoundCount: '{{count}} elämystä löytyi',
  profileImageOfHost: 'Isännän {{hostName}} profiilikuva',
  reserve: 'Varaa',
  reserveLandingPageTitle: 'Aktiviteetit ja mukavuudet',
  reserveProductCardTitle: 'Aktiviteetit',
  reserveProductPageTitle: 'Varaa aktiviteetteja ja mukavuuksia',
  resultsPageTitle: 'Varaa elämyksiä ja aktiviteetteja',
};
